import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSnackbar } from "notistack";
import ListMaker from "./ListMaker";
import { UseProduct } from "./UseProduct";

export default function EditLevel5(props) {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [level5, setLevel5] = React.useState({
    characteristics: props.product.characteristics,
    warnings: props.product.warnings,
    keepConditions: props.product.keepConditions,
    appurtenances: props.product.appurtenances,
    usages: props.product.usages,
  });

  useEffect(() => {
    if (props.fire) {
      Validation5();
    }
  }, [props.fire]);

  return (
    <Accordion
      expanded={props.expanded === "panel5"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel5")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>مرحله پنجم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box>
          <Grid container>
            <ListMaker
              name="مشخصه های"
              setter={(list) => {
                setLevel5({
                  ...level5,
                  characteristics: list,
                });
              }}
              deleteRow={(orderRow) => {
                let newArray = level5.characteristics.filter(
                  (elem) => elem.orderRow !== orderRow
                );

                setLevel5({
                  ...level5,
                  characteristics: newArray,
                });
              }}
              list={
                level5.characteristics &&
                level5.characteristics.sort((a, b) => a.orderRow - b.orderRow)
              }
            ></ListMaker>

            <ListMaker
              name="هشدارهای"
              setter={(list) => {
                setLevel5({
                  ...level5,
                  warnings: list,
                });
              }}
              deleteRow={(orderRow) => {
                let newArray = level5.warnings.filter(
                  (elem) => elem.orderRow !== orderRow
                );
                setLevel5({
                  ...level5,
                  warnings: newArray,
                });
              }}
              list={
                level5.warnings &&
                level5.warnings.sort((a, b) => a.orderRow - b.orderRow)
              }
            ></ListMaker>
            <ListMaker
              name="شرایط نگهداری"
              setter={(list) => {
                setLevel5({
                  ...level5,
                  keepConditions: list,
                });
              }}
              deleteRow={(orderRow) => {
                let newArray = level5.keepConditions.filter(
                  (elem) => elem.orderRow !== orderRow
                );
                setLevel5({
                  ...level5,
                  keepConditions: newArray,
                });
              }}
              list={
                level5.keepConditions &&
                level5.keepConditions.sort((a, b) => a.orderRow - b.orderRow)
              }
            ></ListMaker>
            <ListMaker
              name="متعلقات"
              setter={(list) => {
                setLevel5({
                  ...level5,
                  appurtenances: list,
                });
              }}
              deleteRow={(orderRow) => {
                let newArray = level5.appurtenances.filter(
                  (elem) => elem.orderRow !== orderRow
                );
                setLevel5({
                  ...level5,
                  appurtenances: newArray,
                });
              }}
              list={
                level5.appurtenances &&
                level5.appurtenances.sort((a, b) => a.orderRow - b.orderRow)
              }
            ></ListMaker>
            <ListMaker
              name="موارد مصرف"
              setter={(list) => {
                setLevel5({
                  ...level5,
                  usages: list,
                });
              }}
              deleteRow={(orderRow) => {
                let newArray = level5.usages.filter(
                  (elem) => elem.orderRow !== orderRow
                );
                setLevel5({
                  ...level5,
                  usages: newArray,
                });
              }}
              list={
                level5.usages &&
                level5.usages.sort((a, b) => a.orderRow - b.orderRow)
              }
            ></ListMaker>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel4");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => Validation5()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation5() {
    if (props.fire == false) {
      enqueueSnackbar("مرحله پنجم با موفقیت تکمیل شد", {
        variant: "success",
        autoHideDuration: 2000,
      });
      props.setExpanded("panel6");
    }
    props.fill(level5);
  }
}
